import React, { FC, useCallback, useContext, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { getSVG } from '@/components/Common/styles/mixins';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import AnimatedCard from '../../../AnimatedCard';
import styles from './index.module.scss';

const PointServiceCard: FC = () => {
  const store = useContext(NolPromotionStoreCtx);
  const getResourcePath = useCallback((path: string): string => getSVG(`/static/images/nol-promotion/v9/${path}`), []);
  const claimDiscountProps = useMemo(() => {
    return {
      type: 'gray' as const,
      supTitle: <div className={styles.cardSupTitle}>이벤트 3</div>,
      title: (
        <div className={styles.cardTitle}>
          선지급 포인트 서비스
          <br />
          <div className={styles.blue}>NOL 포인트 긴급적립</div>
        </div>
      ),
      image: (
        <img
          className={styles.claimDiscountImage}
          src={getResourcePath('point-service-card.png')}
          alt={'선지급 포인트 서비스'}
        />
      ),
      descriptions: [
        {
          text: (
            <>
              NOL·NOL인터파크(NOL 인터파크투어/NOL 티켓)· <br />
              트리플에서 사용 가능한 최대 30만 NOL 포인트 긴급적립
            </>
          ),
          bold: true,
          normal: false,
          hideDotPrefix: true,
          marginBottom: true,
        },
        {
          text: '혜택 적용 : 현대카드 홈페이지 및 앱에서 NOL 포인트 긴급적립 신청 후 혜택 제공',
          bold: true,
          normal: true,
        },
        {
          text: (
            <>
              <b>대상 카드 : NOL 카드</b>
              <br />
              *본인 카드만 신청 가능, 가족카드 불가
            </>
          ),
          bold: false,
          normal: true,
        },
        {
          text: (
            <>
              신청 NOL 포인트 : 10만/20만/30만
              <br />
              NOL 포인트 중 택1
            </>
          ),
          bold: false,
          normal: true,
        },
        {
          text: '상환 기간 : 24개월',
          bold: false,
          normal: true,
        },
        {
          text: '상세 내용은 [NOL 포인트 긴급적립 자세히 보기]에서 확인',
          bold: false,
          normal: true,
        },
        {
          text:
            '단, NOL· NOL 인터파크(NOL 인터파크투어/NOL 티켓) · 트리플 정책에 따라, 국내선 항공권 등 일부 카테고리 및 상품의 경우 NOL 포인트 사용 불가',
          bold: false,
          normal: true,
        },
      ],
      link: {
        onLinkClick: () => (location.href = 'https://content.yanolja.com/event/306'),
        onLinkTitle: 'NOL 포인트 긴급적립 자세히 보기',
      },
    };
  }, []);

  return (
    <AnimatedCard
      className={styles.claimDiscountCardContainer}
      {...claimDiscountProps}
      logData={{
        object: '자세히 보기',
        objectType: 'Btn',
        objectContainer: 'NOL에서 지금 받는 NOL 이벤트 혜택',
        motherPageVersion: store.version,
        motherPageSectionType: '프로모션',
        motherPageSectionName: '첫 결제 청구할인 2만원',
        motherPageSectionNameSubTitle: '',
        deepLinkUri: '',
      }}
    />
  );
};

export default observer(PointServiceCard);
